/**
 * CountyNavLinks — top-of-nav quick links to the 3 SEO county landing pages.
 * Reused in LandingPage, CountyLandingPage, SampleMemoPage navs.
 *
 * - Hidden on small screens (those use the Locations dropdown via this same
 *   set of links, also exposed on mobile menu in the future).
 * - Highlights the active county when you're already on one of them.
 */
import { useNavigate, useLocation } from "react-router-dom";

const COUNTY_LINKS = [
  { label: "Los Angeles", path: "/california/los-angeles-adu-permit", testid: "nav-county-la" },
  { label: "San Diego", path: "/california/san-diego-adu-permit", testid: "nav-county-sd" },
  { label: "Bay Area", path: "/california/bay-area-adu-permit", testid: "nav-county-bay" },
];

const CountyNavLinks = ({ className = "" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {COUNTY_LINKS.map((c) => {
        const active = location.pathname === c.path;
        return (
          <button
            key={c.path}
            onClick={() => navigate(c.path)}
            data-testid={c.testid}
            className={`text-sm px-3 py-1.5 rounded-full transition-colors ${
              active
                ? "bg-accent/12 text-accent font-semibold"
                : "text-foreground/80 hover:text-foreground hover:bg-muted"
            }`}
          >
            {c.label}
          </button>
        );
      })}
    </div>
  );
};

export default CountyNavLinks;
